import React, { useEffect } from 'react';
import { isBrowser } from "react-device-detect";
import { Switch, BrowserRouter as Router, Redirect } from 'react-router-dom';
import LoginPage from '../pages/LoginPage';
import LoginPageAD from '../pages/LoginPageAD';
import Logout from '../components/Logout/index';
import HomePage from '../pages/HomePage';
import MyCalendarPage from '../pages/MyCalendarPage';
import LeaveApplicationPage from '../pages/LeaveApplicationPage';
import CompLeaveRequestPage from '../pages/CompLeaveRequestPage';
import MyLeavePage from '../pages/MyLeavePage';
import LeaveApprovalPage from '../pages/LeaveApprovalPage';
import MyTeamPage from '../pages/MyTeamPage';
import EmployeeRecordPage from '../pages/EmployeeRecordPage';
import ApproversConfigPage from '../pages/ApproversConfigPage';
import ErrorPage from '../pages/ErrorPage';
import PrivateRoute from '../components/Router/Component/PrivateRoute'
import { Authorization } from '../components/Login/component/Authorization';
import CompLeaveReqsApproval from "../components/CompLeaveReqsApproval";
import CompLeaveApprovalPage from "../pages/CompLeaveApprovalPage";
import MyCompLeaveReqsPage from "../pages/MyCompLeaveRequestPage";
import ApprovalHistoryPage from '../pages/ApprovalHistoryPage';
import BalancePage from '../pages/BalancePage';
import { setLocalStorageSettings } from '../components/Function/globalFunction';
import LeaveRecord from '../components/HRAdmin/EmployeeRecord/Edit/components/LeaveRecord';
import CashOutPage from '../pages/CashOutPage';
import OTHistoryPage from '../pages/OTHistoryPage';
import ScrollTop from '../components/UIComponent/ScrollTop';

const Route = require("react-router-dom").Route;
let showHR;
if (isBrowser === true) {
    showHR = true;
} else {
    showHR = false;
}

let showLoginAD = true;
let loginMethod = process.env.REACT_APP_LOGIN_METHOD;

if (loginMethod && loginMethod == 'username') {
    showLoginAD = false;
}

function Routes() {

    return (
        <Router>
            <Switch>
                {showLoginAD ? ([
                    <Route key="root" path="/" exact component={LoginPageAD} />,
                    <Route key="login" path="/login" exact component={LoginPageAD} />
                ])
                    :
                    ([
                        <Route key="root" path="/" exact component={LoginPage} />,
                        <Route key="login" path="/login" exact component={LoginPage} />
                    ])
                }
                <Route key="authorization" path="/auth" component={Authorization} />
                <PrivateRoute key="home" path="/home" component={HomePage} />
                <PrivateRoute key="leave_application" path="/leave_application" exact render={() => <MyCalendarPage />} />
                <PrivateRoute key="new_application" path="/new_application" exact render={() => <LeaveApplicationPage />} />
                <PrivateRoute key="myleave" path="/myleave" exact render={() => <MyLeavePage />} />
                <PrivateRoute key="myleave/:id" path="/myleave/:id" exact render={({ match, location }) => {
                        const queryParams = new URLSearchParams(location.search);
                        const source = queryParams.get('source');
                        return <MyLeavePage routing={true} routingId={match.params.id} source={source} />;
                }} />
                <PrivateRoute key="leave_approval" path="/leave_approval" exact render={() => <LeaveApprovalPage />} />
                <PrivateRoute key="leave_approval/:id" path="/leave_approval/:id" exact render={({ match, location }) => {
                        const queryParams = new URLSearchParams(location.search);
                        const source = queryParams.get('source');
                        return <LeaveApprovalPage routing={true} routingId={match.params.id} source={source} />;
                }} />
                <PrivateRoute key="approval_history" path="/approval_history" exact render={() => <ApprovalHistoryPage />} />
                <PrivateRoute key="myteam" path="/myteam" exact render={() => <MyTeamPage />} />
                <PrivateRoute key="myteam/:id" path="/myteam/:id" exact render={({ match, location }) => {
                        const queryParams = new URLSearchParams(location.search);
                        const source = queryParams.get('source');
                        const compLeaveRequest = queryParams.get('compLeaveRequest');
                        return <MyTeamPage routing={true} routingId={match.params.id} source={source} compLeaveRequest={compLeaveRequest} />;
                }} />
                <PrivateRoute key="logout" path="/logout" exact render={() => <Logout />} />
                <PrivateRoute key="error" path="/error" exact render={() => <ErrorPage />} />
                <PrivateRoute key="comp_leave_request" path="/comp_leave_request" exact render={() => <CompLeaveRequestPage />} />
                <PrivateRoute key="compLeaveReqsApproval" path="/compLeaveReqsApproval" exact render={() => <CompLeaveApprovalPage />} />
                <PrivateRoute key="compLeaveReqsApproval/:id" path="/compLeaveReqsApproval/:id" exact render={({ match }) => <CompLeaveApprovalPage routing={true} routingId={match.params.id} />} />
                <PrivateRoute key="myCompleaveReqs" path="/myCompleaveReqs" exact render={() => <MyCompLeaveReqsPage />} />
                <PrivateRoute key="myCompleaveReqs/:id" path="/myCompleaveReqs/:id" exact render={({ match }) => <MyCompLeaveReqsPage routing={true} routingId={match.params.id} />} />
                <PrivateRoute key="endorsedOTBalance" path="/endorsedOTBalance" exact render={() => <BalancePage />} />
                {showHR && ([
                    <PrivateRoute key="ot_history" path="/ot_history" exact render={() => <OTHistoryPage />} />,
                    <PrivateRoute key="cash_out" path="/cash_out" exact render={() => <CashOutPage />} />,
                    <PrivateRoute key="employee_record_mgt" path="/employee_record_mgt" exact render={() => <EmployeeRecordPage />} />,
                    <PrivateRoute key="employee_record_mgt/leave_record/:id" path="/employee_record_mgt/leave_record/:id" exact render={({ match }) => <LeaveRecord routing={true} routingId={match.params.id} />} />,
                    <PrivateRoute key="approvers_configuration" path="/approvers_configuration" exact render={() => <ApproversConfigPage />} />,
                ])
                }
                <Redirect to="/error" />
            </Switch>
            <ScrollTop />
        </Router>
    );
}

export default Routes;
